export default "__VITE_ASSET__iuO3KJ6___"